module.exports = __webpack_public_path__ + "static/media/dinner1.f995a5b1.png";